import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import DecisionDetail from './components/DecisionDetail';
import CAV1Backtest from './components/CAV1Backtest';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/AdminDashboard';

function PrivateRoute({ children }) {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  return (user && token) ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');
  if (!user?.id || !token) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/" element={<PrivateRoute><App /></PrivateRoute>} />
      <Route path="/decisions/:system/:key" element={<PrivateRoute><DecisionDetail /></PrivateRoute>} />
      <Route path="/backtest/cav1" element={<PrivateRoute><CAV1Backtest /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
